import React from "react"
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import * as env from "shared/env";
import { styles } from "./style";

interface OwnProps<T> {
	label: string,
	value?: T,
	sidebarNote?: React.ReactNode,
	tooltip?: string,
	onChange: (value: T) => void,
	maxWidth?: number,
	children?: React.ReactNode,
}

interface Props<T> extends OwnProps<T>, WithStyles<typeof styles> {}

class InternalComponent<T> extends React.Component<Props<T>> {
	public render() {
		const { label, sidebarNote, tooltip, value, onChange, children, maxWidth, classes = {} } = this.props;

		const labelContent = tooltip ? (
			<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
				<span>{label}</span>
				<Mui.Tooltip title={tooltip} placement="right" arrow>
					<Mui.IconButton
						size="small"
						color="primary"
						style={{ padding: 0, width: 20, height: 20 }}
						onMouseDown={(e) => e.preventDefault()}
					>
						<Icons.Info size={16} />
					</Mui.IconButton>
				</Mui.Tooltip>
			</span>
		) : label;

		return (
			<Mui.Grid container direction="row" spacing={2}>
				<Mui.Grid item xs={12} sm className={maxWidth ? classes.fieldContainer : undefined}>
					{env.refreshDesignsDev ? (
						// Label-above field (Figma): no floating/notched MUI label; the outlined Select
						// picks up the themed 12px 16px padding / #ebebeb border / 4px radius.
						(<Mui.FormControl fullWidth variant="outlined">
							<Mui.Typography component="label" className={classes.labelAbove}>
								{labelContent}
							</Mui.Typography>
							<Mui.Select
								fullWidth
								variant="outlined"
								value={value}
								onChange={event => onChange(event.target.value as T)}>
									{children}
							</Mui.Select>
						</Mui.FormControl>)
					) : (
						<Mui.FormControl fullWidth variant="outlined">
							<Mui.InputLabel shrink={tooltip ? true : undefined} style={tooltip ? { pointerEvents: 'auto' } : undefined}>
								{labelContent}
							</Mui.InputLabel>
							<Mui.Select
								fullWidth
								variant="outlined"
								value={value}
								input={
									<Mui.OutlinedInput
										notched={true}
										label={label} />
								}
								onChange={event => onChange(event.target.value as T)}>
									{children}
							</Mui.Select>
						</Mui.FormControl>
					)}
				</Mui.Grid>
				{sidebarNote && (
					<Mui.Grid item xs={12} sm>
						<Mui.Typography>
							<strong>Note:</strong>
							{" "}
							{sidebarNote}
						</Mui.Typography>
					</Mui.Grid>
				)}
			</Mui.Grid>
		);
	}
}

const StyledComponent = withStyles(InternalComponent, styles);

export const FullWidthDropdown = StyledComponent as unknown as <T = unknown>(props: OwnProps<T>) => JSX.Element;
